import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';

function Dropdown(_ref) {
  var options = _ref.options,
      value = _ref.value,
      placeholder = _ref.placeholder,
      _onChange = _ref.onChange,
      _onFocus = _ref.onFocus,
      _onBlur = _ref.onBlur,
      classNamePrefix = _ref.classNamePrefix,
      isClearable = _ref.isClearable,
      isDisabled = _ref.isDisabled;

  if (!options) {
    return null;
  } // we return null when nothing is found because undefined does not clear the old value


  var selectedOption = options.find(function (option) {
    return option.value === value;
  }) || null;
  return React.createElement(Select, {
    isDisabled: isDisabled,
    isClearable: isClearable,
    placeholder: placeholder,
    options: options,
    value: selectedOption,
    onChange: function onChange(option) {
      _onChange && _onChange(option && option.value || option);
    },
    onFocus: function onFocus() {
      _onFocus && _onFocus();
    },
    onBlur: function onBlur() {
      _onBlur && _onBlur();
    },
    classNamePrefix: classNamePrefix
  });
}

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any
  })),
  value: PropTypes.any,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  classNamePrefix: PropTypes.string,
  isClearable: PropTypes.bool,
  isDisabled: PropTypes.bool
};
Dropdown.defaultProps = {
  classNamePrefix: 'SearchableDropdown'
};
export default Dropdown;